import {ServiceRequest} from "../utils/service-request"
import {MOTOR_CADASTRO_EMPRESAS_PATH} from "../utils/api-routes"

export class MotorEmpresasService {

    constructor() {
        this.request = new ServiceRequest()
    }

    async loadEmissoes(cpfcnpj){
        const params = new URLSearchParams()

        if (cpfcnpj) params.append("cpfcnpj", cpfcnpj)
        
        const query = params.toString() ? `?${params.toString()}` : ""
        return this.request.get (`${MOTOR_CADASTRO_EMPRESAS_PATH}/emissoes${query}`)       
    }
}

